<template>
  <el-link
    v-if="fileAvailable"
    type="primary"
    @click.stop="download"
  >
    {{ name }}
  </el-link>
  <span v-else>
    {{ name }}
  </span>
</template>

<script>
  export default {
    props: {
      id: {
        type: Number,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      fileAvailable: {
        type: Boolean,
        required: true
      },
    },
    methods: {
      async download() {
        try {
          const csv = await axios({
            url: `api/imports/download/${this.id}`,
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(csv, 'import.csv');
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
</script>
